import React, {useEffect} from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import {useRecoilState, useRecoilValue} from 'recoil';
import {bidmiiProReferralBannerOpenState} from '../../../recoil/dialogs/DialogsRecoil';
import {Close, NewReleases} from '@mui/icons-material';
import useScreenWidth from '../../../common/useScreenWidth';
import {userState} from '../../../recoil/user/userAtom';
import {theme} from '../../../Theme';
import {useHistory} from 'react-router-dom';
import Anchor from '../../../common/Anchor';
import useBidmiiProTier from '../../../common/useBidmiiProTier';

export default function BidmiiProReferralBanner(props: $TSFixMe) {
  const width = useScreenWidth();
  const history = useHistory();
  const user = useRecoilValue(userState);
  const proTier = useBidmiiProTier();
  const [referralBannerOpen, setReferralBannerOpen] = useRecoilState(
    bidmiiProReferralBannerOpenState,
  );

  useEffect(() => {
    if (
      user?.initialised &&
      user?.userType === 'BIDDER' &&
      proTier === 0 &&
      !localStorage.getItem('bidmiiProReferralBannerShown')
    ) {
      setReferralBannerOpen(true);
    } else {
      setReferralBannerOpen(false);
    }
  }, [proTier, setReferralBannerOpen, user]);

  const handleClose = () => {
    setReferralBannerOpen(false);
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
    localStorage.setItem('bidmiiProReferralBannerShown', 1);
  };

  if (
    !referralBannerOpen ||
    !user?.userType ||
    user?.userType === 'REQUESTER'
  ) {
    return null;
  }

  return (
    <>
      <Toolbar
        style={{backgroundColor: theme.palette.blue.main, minHeight: 56}}>
        <Grid
          container
          justifyContent={width > 600 ? 'center' : 'flex-start'}
          alignItems="center">
          {width > 600 && (
            <NewReleases color="secondary" style={{marginRight: 8}} />
          )}
          <Typography
            variant="subtitle1"
            style={{
              color: theme.palette.secondary.main,
              fontSize: width > 600 ? 16 : 13,
              maxWidth: props.main && width > 600 ? 'auto' : '200px',
              lineHeight: width > 600 ? 1 : 1.3,
            }}>
            Get the tools you need to grow your business with{' '}
            <img
              src="https://cdn.bidmii.com/media/web_assets/bidmii-pro-logo-white.png"
              alt="Bidmii Pro logo"
              style={{
                width: width > 600 ? 93 : 80,
                marginTop: -3,
                marginLeft: 2,
              }}
            />
          </Typography>
          <Anchor href="/bidmii-pro">
            <Button
              onClick={() => history.push('/bidmii-pro')}
              style={{
                fontSize: width > 600 ? 16 : 13,
                marginLeft: width > 600 ? 24 : 12,
                color: theme.palette.secondary.main,
                borderBottom: `1px solid ${theme.palette.secondary.main}`,
                borderRadius: 0,
                lineHeight: '16px',
                padding: 0,
              }}>
              LEARN MORE
            </Button>
          </Anchor>
        </Grid>
        {props.main && (
          <IconButton
            style={{position: 'absolute', right: width > 600 ? 8 : 0}}
            onClick={handleClose}
            size="large">
            <Close color="primary" fontSize="small" />
          </IconButton>
        )}
      </Toolbar>
    </>
  );
}
